let config = {
  noticeGroups: [
    {
      name: 'all',
      text: '全部'
    },
    {
      name: 'read',
      text: '已读'
    },
    {
      name: 'unread',
      text: '未读'
    },
    {
      name: 'star',
      text: '星标'
    }
  ],
  pageSize: 20
}
export default config



// WEBPACK FOOTER //
// ./src/components/drawer-notice/config.js